import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/areas.action'
import { onHttpError } from 'helpers/access.helper'
import getAreasList from 'api/administration/participants/GetAreas'

async function getList() {
  return await getAreasList()
}

function* getAreasEffectSaga() {
  try {
    const data = yield call(getList)
    yield put(fromActions.Actions.getAreasListSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* getAreasWatcherSaga() {
  yield takeLatest(fromActions.GET_AREAS_LIST, getAreasEffectSaga)
}
